import { BaseEditViewStore } from 'core/stores';
import { UserEmailSignatureEditModalForm } from 'application/user/forms';
import { CoreUserService } from 'application/user/services';
import { action } from 'mobx';

class UserEmailSignatureEditModalViewStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const userId = componentProps.modalParams.data.userId;
        const userSetting = componentProps.modalParams.data.userSetting;
        const coreUserService = new CoreUserService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'user-email-signature',
            id: userSetting && userSetting.userId,
            Form: UserEmailSignatureEditModalForm,
            actions: () => {
                return {
                    get: async () => {
                        // const response = await service.get(id, opts);
                        return {};
                    },
                    update: async (resource) => {
                        const response = await coreUserService.updateUserSetting(resource);
                        return response.data;
                    }
                }
            },
            FormClass: UserEmailSignatureEditModalForm,
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.emailSignature = '';
        if(userSetting){
            this.form.$("emailSignature").set(userSetting.emailSignature);
            this.emailSignature =  userSetting.emailSignature
        }
        this.userId = userId;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            await this.actions.update({
                ...resource,
                userId: this.userId
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate("Email Signature Successfully Updated."), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.update) return;
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            await this.actions.update({
                ...resource,
                userId: this.userId
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate("Email Signature Successfully Updated."), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success(name);
    }
}

export default UserEmailSignatureEditModalViewStore;
